export const GET_CITIZENSHIP_LIST = 'GET_CITIZENSHIP_LIST';
export const GET_CITIZENSHIP_LIST_SUCCESS = 'GET_CITIZENSHIP_LIST_SUCCESS';
export const GET_CITIZENSHIP_LIST_ERROR = 'GET_CITIZENSHIP_LIST_ERROR';
export const GET_CITIZENSHIP_SELECT_ITEMS = 'GET_CITIZENSHIP_SELECT_ITEMS';
export const GET_CITIZENSHIP_SELECT_ITEMS_SUCCESS = 'GET_CITIZENSHIP_SELECT_ITEMS_SUCCESS';
export const GET_CITIZENSHIP_SELECT_ITEMS_ERROR = 'GET_CITIZENSHIP_SELECT_ITEMS_ERROR';
export const ADD_FACULTY_CITIZENSHIP = 'ADD_FACULTY_CITIZENSHIP';
export const ADD_FACULTY_CITIZENSHIP_SUCCESS = 'ADD_FACULTY_CITIZENSHIP_SUCCESS';
export const ADD_FACULTY_CITIZENSHIP_ERROR = 'ADD_FACULTY_CITIZENSHIP_ERROR';
export const UPDATE_FACULTY_CITIZENSHIP = 'UPDATE_FACULTY_CITIZENSHIP';
export const UPDATE_FACULTY_CITIZENSHIP_SUCCESS = 'UPDATE_FACULTY_CITIZENSHIP_SUCCESS';
export const UPDATE_FACULTY_CITIZENSHIP_ERROR = 'UPDATE_FACULTY_CITIZENSHIP_ERROR';
export const DELETE_FACULTY_CITIZENSHIP = 'DELETE_FACULTY_CITIZENSHIP';
export const DELETE_CITIZENSHIP_SUCCESS = 'DELETE_CITIZENSHIP_SUCCESS';
export const DELETE_CITIZENSHIP_ERROR = 'DELETE_CITIZENSHIP_ERROR';
export const SET_FORMIK_INITIAL_VALUES = 'SET_FORMIK_INITIAL_VALUES';
export const RESET_FORMIK_INITIAL_VALUES = 'RESET_FORMIK_INITIAL_VALUES';